import { Link } from "react-router-dom";
import { IoMdArrowDropdown } from "react-icons/io";

const NavMenu = ({
  navItems,
  activeNav,
  setActiveNav,
  activeDropdown,
  setActiveDropdown,
  handleMouseLeave,
  toggleDropdown,
  isMenuOpen,
  className,
  hover,
  py,
  dropdownItemClass,
  displayClass,
}) => (
  <nav
    className={`transition-all duration-300 lg:flex lg:items-center lg:justify-center font-bold ${
      isMenuOpen ? "block" : "hidden"
    } ${className}`}
  >
    <ul className={`${displayClass}  text-sm  uppercase font-bold`}>
      {navItems
        ?.filter((navItem) => navItem.status === true)
        .map((navItem) => {
          // COMMUNITY link: render as simple link, no submenus
          const isCommunity = String(navItem.label || "").toLowerCase() === "community";
          const isDropdown = !isCommunity && navItem.type === "DROPDOWN";
          return (
          <li
            key={navItem.id}
            className={isDropdown ? "relative cursor-pointer" : ""}
            onMouseLeave={
              isDropdown ? handleMouseLeave : undefined
            }
            onClick={() => isDropdown && toggleDropdown(navItem.label)}
          >
            {isDropdown ? (
              <>
                <div
                  className={`${hover} flex justify-between lg:justify-center items-center ${
                    activeNav === navItem.label.toLowerCase()
                      ? "bg-[#BA1500]"
                      : ""
                  }`}
                >
                  <span>{navItem.label}</span>
                  <IoMdArrowDropdown size={24} />
                </div>
                {activeDropdown === navItem.label && (
                  <ul className="absolute z-50 left-0 w-full md:w-48 bg-white text-black shadow-md rounded-md capitalize font-bold">
                    {(navItem.dropdownItems || [])
                      .filter((dropdownItem) => dropdownItem.status !== false)
                      .map((dropdownItem) => (
                        <li key={dropdownItem.id}>
                          <Link
                            to={dropdownItem.path}
                            className={`${hover} ${dropdownItemClass} px-2 text-left ${py} block ${
                              activeNav === dropdownItem.label.toLowerCase()
                                ? "bg-[#BA1500] text-white"
                                : ""
                            }`}
                            onClick={() =>
                              setActiveNav(dropdownItem.label.toLowerCase())
                            }
                          >
                            {dropdownItem.label}
                          </Link>
                        </li>
                      ))}
                  </ul>
                )}
              </>
            ) : (
              <Link
                to={navItem.path || "/"}
                className={`${hover} ${py} block ${
                  activeNav === (navItem.path || "/") ? "bg-[#BA1500]" : ""
                }`}
                onClick={() => setActiveNav(navItem.path || "/")}
              >
                {navItem.label}
              </Link>
            )}
          </li>
        );
        })}
    </ul>
  </nav>
);

export default NavMenu;
